import {api,ApiError} from '../../lib/api';
import {queryCache} from '../../lib/queryCache';

export class UnconfirmedTrashError extends Error {}
type TrashRequest={source?:string;ids:string[];resourceId?:string};
type TrashList={items:{source:string;id:string}[]};
const isUncertain=(error:unknown)=>error instanceof TypeError||(error instanceof ApiError&&error.code==='unavailable');

// This command is idempotent on the server. Never retry other mutations here.
export async function submitTrash(input:TrashRequest,epoch:number,uncertain=false,isCurrent=()=>true){
 const checkSession=()=>{if(epoch!==queryCache.sessionEpoch)throw new ApiError('forbidden','Adgangen er ændret. Hent indholdet igen.');};
 for(let attempt=0;attempt<2;attempt++){
  checkSession();
  if(!isCurrent())return;
  try{
   await api('trashDrafts',input);
   checkSession();
   return;
  }catch(error){
   checkSession();
   if(!isCurrent())return;
   if(!uncertain&&!isUncertain(error))throw error;
   uncertain=true;
   try{
    const result=await api<TrashList>('listTrashedDrafts');
    checkSession();
    if(!isCurrent())return;
    if(input.ids.every(id=>result.items.some(item=>item.source===input.source&&item.id===id))){
     queryCache.invalidate();
     return;
    }
   }catch{
    checkSession();
   }
   if(!isUncertain(error))break;
  }
 }
 throw new UnconfirmedTrashError('Flytningen er endnu ikke bekræftet. Prøv igen, når forbindelsen er tilbage.');
}
